import type { GovernmentReportingServiceType } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateItemJurisdictionCodeMutationAtom = createMutationAtomFactory(
  'settings.itemJurisdictionCodeUpdate',
  (params: {
    id: string;
    serviceType?: GovernmentReportingServiceType;
    code?: string;
    isReportable?: boolean;
  }) => ({
    complianceComplianceItemJurisdictionCodeUpdate: {
      __args: {
        id: params.id,
        input: {
          serviceType: params.serviceType,
          code: params.code,
          isReportable: params.isReportable,
        },
      },
      id: true,
    },
  }),
);
